import React from 'react';
import classNames from 'classnames';

export default ({glyph, className, label}) => (
  <i
    className={classNames('glyphicon', 'glyphicon-' + glyph, className)}
    aria-hidden={!label}
    aria-label={label}
  />
);
